<script setup lang="ts">
  defineProps<{
    notes: string | null;
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-notes"
    class="flex flex-col gap-2 px-6 py-8"
  >
    <span class="text-xs font-semibold text-gray-07">Observações:</span>
    <p
      data-testid="training-control-notes"
      class="min-h-11 whitespace-pre-line rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
    >
      {{ notes ?? '' }}
    </p>
  </section>
</template>
